import { render, staticRenderFns } from "./e-money-create.vue?vue&type=template&id=55933a0b&"
import script from "./e-money-create.vue?vue&type=script&lang=js&"
export * from "./e-money-create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports